import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'

export const themedDividerStyle = StyleSheet.create({
	divider: {
		alignSelf: 'center',
		width: '100%',
		backgroundColor: colorList.GREY.primary
	}
})
